import "./SkipButtonStory.css";
import ContentPage from "./ContentPage";
import { ReactComponent as ButtonHypothesis1 } from "./static/images/ButtonHypothesis1.svg";
import { ReactComponent as ButtonHypothesis2 } from "./static/images/ButtonHypothesis2.svg";
import Button from "./Button";
import { goToPage } from "./Slide";
import { ReactComponent as LeftArrow } from "./static/icons/LeftArrow.svg";
import AnimatedDiv from "./AnimatedDiv";
function SkipButtonStory() {
  return (
    <ContentPage>
      <h2>The story of [nonexistent] skip button</h2>
      <p>
        If you managed to look into the case study got this far, you are
        probably wondering, “What's with the skip button? Why your onboarding
        doesn't have it?”
      </p>
      <h3>Process</h3>
      <p>
        During the design process of the new onboarding flow for Uproad app I
        made the hypothesis:
        <AnimatedDiv>
          <ButtonHypothesis1 />
        </AnimatedDiv>
      </p>
      <p>
        Skip button can be used in onboarding flow of an app that is similar to
        other ones on the market. Users won't find themselves having tough time
        to understand how the app works if they've decided to skip an onboarding
        step.{" "}
      </p>
      <p>
        This doesn't apply to Uproad. Uproad is a complex product with multiple
        technical limitations. These limitations make user experience more
        difficult. To address that we needed to make sure that the user actually
        would read and comprehend the app's “quirks”.
      </p>
      <p>
        If skip button isn't there, user would search for in on the screen
        because it's a common UX pattern. Not finding it will create discomfort
        during the first interaction with the app.
      </p>
      <AnimatedDiv>
        <ButtonHypothesis2 />
      </AnimatedDiv>
      <p>
        I conducted one-on-one interviews with the existing users to check these
        hypotheses. In order to do this, I created 2 prototypes with and without
        the Skip button and divided the respondents into 2 groups. I checked:
      </p>
      <p>1. How they felt about nonexistence of Skip button</p>
      <p>2. Whether they actually skipped when Skip button was available</p>
      <p>3. Whether the user remembered what that'd read</p>
      <h3>Result</h3>
      <p>
        <p>1. Those who had Skip button in the UI did press it </p>
        <p>
          2. Those who could skip didn't read the text thoroughly and could
          barely remember the content. They mainly remembered the illustrations.
        </p>
        <p>
          3. Those who couldn't skip were not happy, but they only indicated
          slight dissatisfaction.
        </p>
        <p>
          {" "}
          4. Those who couldn't skip could answer all the questions on how the
          app works.
        </p>
        <p>
          Based on these I made a decision that the final designs wouldn't have
          the Skip button.{" "}
        </p>
      </p>
      <Button
        className="goToCaseButton"
        variant="complex"
        text="BACK TO UPROAD CASE"
        onClick={() => goToPage("/case3")}
        icon={<LeftArrow />}
      />
    </ContentPage>
  );
}

export default SkipButtonStory;
